export const snackbarInitialState = {
  toggleSnackbar: false,
  snackbarMessage: "",
};

export interface SnackbarStateType {
  toggleSnackbar: boolean;
  snackbarMessage: string;
}
